import React from 'react';

import clsx from 'clsx';

import { Stack, makeStyles } from '@gogame/components';

const useStyles = makeStyles(
  () => {
    return {
      root: {
        display: 'flex',
        flexGrow: 1,
        padding: '8px 16px 16px',
      },
    };
  },
  { name: 'GgScreen' }
);

const ScreenBody = ({ children, ...props }) => {
  const classes = useStyles();
  return (
    <Stack
      direction={'column'}
      className={clsx(classes.root)}
      data-cy={`screen`}
      spacing={2}
      {...props}
    >
      {children}
    </Stack>
  );
};

export default ScreenBody;
